<template>
  <figure class="BodyContentImage">
    <SanityImage :asset="value.asset" :class="{ addBorder: value.addBorder }" />
    <figcaption v-if="value.caption" class="caption">{{ value.caption }}</figcaption>
  </figure>
</template>

<script setup>
const { value } = defineProps({ value: Object })
</script>

<style scoped>

.BodyContentImage {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.caption {
  font-size: var(--font-size-2);
  font-style: italic;
}

.addBorder {
  border: thin solid var(--hairline-color);
}
</style>
